import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import CommentIcon from "../assets/blogs/CommentIcon";
import Lottie from "lottie-react";
import noblogs from "../../public/error/noblogs.json";
import NoBlogs from "./NoBlogs";
export default function BlogCard({ blogs, t }) {
  const router = useRouter();
  const [lang, setLang] = useState(router.locale);
  return (
    <>
      <div className="flex flex-col lg:grid md:grid gap-6 text-neutral-600 grid-cols-12 relative">
        {Array.isArray(blogs) && blogs.length > 0 ? (
          blogs?.map((blog, index) => {
            const date = blog.date;
            const newDate = new Date(date);
            const shortDate = newDate.toLocaleDateString();
            return (
              <Link key={blog?._id} href={`/blogs/${blog._id}`}>
                <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4 hover:cursor-pointer relative">
                  <div
                    className="group overflow-hidden block relative rounded-[10px] mx-auto 
                    w-full h-[292px] lg:h-[326px] xl:h-[21vw]
                  "
                  >
                    <Image
                      alt="Our Blogs"
                      src={blog?.image ? blog?.image : "/blog_default.png"}
                      className=" rounded-[10px] inset-0 duration-700 ease-in-out w-full   object-cover transition-opacity group-hover:opacity-70"
                      layout="fill"
                      quality={100}
                    />
                    <div className="absolute h-32 min-w-[100%] max-w-[100%]  rounded-[10px] bottom-0 left-0 bg-[#0101404D] backdrop-blur-md duration-700  ease-in-out  group-hover:h-full drop-shadow-lg">
                      <div
                        className={`relative duration-300 ease-in-out ${
                          lang == "ar" ? "pr-8" : "pl-6"
                        } pt-0`}
                      >
                        <button className="rounded-[10px] bg-[#BE72F3] px-2.5 py-2.5 text-sm -translate-y-5 font-medium uppercase tracking-widest ml-0 duration-1000 ease-in-out group-hover:translate-y-0 group-hover:mt-8 text-white">
                          {shortDate}
                        </button>
                        <div className="transform duration-300 ease-in-out transition-all group-hover:translate-y-8 ">
                          <div className="font-bold max-h-fit text-[24px] w-full -mt-3 leading-[27px] h-full group group-hover:h-full text-white">
                            <div
                              className={`h-14 group-hover:h-32 max-w-[400px] ${
                                lang == "ar" ? "ml-5" : "mr-5"
                              } overflow-hidden group-hover:text-ellipsis`}
                            >
                              <div className="max-h-[105px] overflow-hidden text-ellipsis">
                                <p>{blog?.title}</p>
                              </div>
                              <span className="text-[16px] font-[400] capitalize opacity-0 duration-600 ease-in-out group-hover:opacity-100 text-[#0AF0DD]">
                                {blog?.categoryName[lang]}
                              </span>
                            </div>

                            <span className="text-[16px] font-[400] capitalize opacity-100 group-hover:opacity-0 ease-in-out text-[#0AF0DD]">
                              {blog?.categoryName[lang]}
                            </span>
                          </div>
                          <p></p>
                        </div>
                      </div>

                      <div
                        className={`opacity-0 duration-300 p-8 text-white delay-75 ease-in-out group-hover:opacity-100 text-sm items-end absolute bottom-0 ${
                          lang == "ar" ? "right-0" : "left-0"
                        }`}
                      >
                        <div className="flex row gap-1">
                          <span className="mr-1 h-[21px] w-[21px]">
                            <CommentIcon />
                          </span>
                          <span className="text-[18px] font-[700]">
                            {blog?.comments?.length}
                          </span>
                          <span className="mt-px text-[12px] font-[400]">
                            {t("comments")}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })
        ) : (
          <>
            <div className="w-full col-span-12 flex justify-center items-center">
              <NoBlogs />
            </div>
          </>
        )}
      </div>
    </>
  );
}
